/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useParams } from "react-router-dom";
import React, { useEffect, useRef } from "react";

export default function CalendarDetails({
  currentCalendar,
  handleCalendarEdit,
}) {
  const params = useParams();
  const labelRef = useRef();
  useEffect(() => {
    if (params.calendarUUID === "create_new") {
      labelRef.current.select();
    }
  }, [params.calendarUUID]);

  return (
    <div className="mb-5">
      <h3>Calendar details</h3>
      <div>
        <div className="form calendar-form">
          <div className="mb-3">
            <label className="form-label">Label</label>
            <input
              ref={labelRef}
              type="text"
              className="form-control"
              placeholder="Calendar Label"
              value={currentCalendar?.Label}
              name="Label"
              onChange={handleCalendarEdit}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Description </label>
            <textarea
              type="text"
              className="form-control"
              placeholder="Description"
              value={currentCalendar?.Description}
              name="Description"
              onChange={handleCalendarEdit}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Total Capacity </label>
            <input
              type="number"
              className="form-control"
              placeholder="Total Capacity"
              value={currentCalendar?.TotalCapacity || ""}
              name="TotalCapacity"
              onChange={handleCalendarEdit}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Per Event Capacity</label>
            <input
              type="number"
              className="form-control"
              placeholder="Per Event Capacity"
              value={currentCalendar?.CapacityPerEvent || ""}
              name="CapacityPerEvent"
              onChange={handleCalendarEdit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
